module.exports = new __parcel__URL__("global_tws_blackbg_v2.dc0b55cb.png").toString();